/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'per-person': {
    width: 32,
    height: 32,
    viewBox: '-8 -8 48 48',
    data: '<g _stroke="#000" stroke-width="1.5" _fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"><path pid="0" d="M5 27c.018-1.572.345-3.123.962-4.568.674-1.35 3.49-2.284 7.026-3.594.956-.353.799-2.85.375-3.318a7.048 7.048 0 01-1.836-5.468A4.611 4.611 0 0115.997 5a4.611 4.611 0 014.476 5.052c.195 2-.471 3.991-1.836 5.468-.424.468-.58 2.965.375 3.318 3.535 1.31 6.352 2.244 7.026 3.594.617 1.445.943 2.996.962 4.568"/></g>'
  }
})



// WEBPACK FOOTER //
// ./src/assets/icons/per-person.js